// breadcrumb.service.ts

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private breadcrumbsSubject = new BehaviorSubject<string[]>([]);
  breadcrumbs$ = this.breadcrumbsSubject.asObservable();

  private companyInfoSubject = new BehaviorSubject<any>({});
  companyInfo$ = this.companyInfoSubject.asObservable();

  private roleNameSubject = new BehaviorSubject<any>({});
  roleName$ = this.roleNameSubject.asObservable();

  private currentRoutePath: string = '';

  // click on breadcrum link to set clicked value
  private clickedDataSubject = new BehaviorSubject<any>(null);
  clickedData$ = this.clickedDataSubject.asObservable();

  setRoutePath(routePath: string) {
    this.currentRoutePath = routePath;
  }

  getRoutePath() {
    return this.currentRoutePath;
  }

  setBreadcrumbs(breadcrumb: any) {
    this.breadcrumbsSubject.next(breadcrumb);
  }

  setCompanyInfo(companyInfo: any) {
    this.companyInfoSubject.next(companyInfo);
  }
  setRoleName(role: any) {
    this.roleNameSubject.next(role);
  }

  getBreadcrumbs() {
    return this.breadcrumbsSubject.getValue();
  }

  setClickedData(data: any) {
    this.clickedDataSubject.next(data);
  }

  getClickedData() {
    return this.clickedDataSubject.getValue();
  }
}
